import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { BuisnessPromotion } from './../../../models/common';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';

@Component({
  selector: 'sm-coupons-card',
  templateUrl: './coupons-card.component.html',
  styleUrls: ['./coupons-card.component.scss']
})
export class CouponsCardComponent implements OnInit {private _apiSubscription: Subscription = new Subscription();
  @Output()
  onOpenModel: EventEmitter<BuisnessPromotion> = new EventEmitter<BuisnessPromotion>();
  @Output()
  onDeactivatePromo: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  imageLink: { url: string; text: string } = {
    url:
      'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    text: 'Makeup mask',
  };

  onEditPromo() {
    this.onOpenModel.emit(this.promoData);
  }

  onDeactivate() {
    if (confirm('Do you want to deactivate this promotion?')) {
      console.log(this.promoData);
      this.promoData.isDelete = 1;
      this._apiService.updateBuisnessPromotion({
        promotionInfo:{
          hash_id:this.promoData.hash_id,
          isDelete:1
        }
      });
    }
  }

  @Input() promoData: BuisnessPromotion = new BuisnessPromotion();

  constructor(private _apiService: ApiService) {}

  ngOnInit(): void {
    // this._apiSubscription = this._apiService.apiResult.subscribe((response) => {
    //   console.log(response);
    //   if (
    //     response.responseType ===
    //     SM_CONSTANTS.API_UPDATE_BUISNESS_PROMOTION_INFO
    //   ) {
    //     this.onDeactivatePromo.emit(true);
    //   }
    // });
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this._apiSubscription.unsubscribe();
  }

 

  

}
